/*eslint-env browser */
/* eslint-disable no-empty-function */
/* eslint-disable no-console */
/* eslint-disable @typescript-eslint/no-empty-function */
import jwt_decode from 'jwt-decode'
import { AppStorage, Token } from './storage.helpers'
import { Routes } from '@src/constants/routes'
import { storagePrefix } from '@src/constants/constants'
import AuthService from '@src/modules/oauth/services/auth.service'
import { isEmpty } from 'lodash'

export const EVENT_TOKEN_EXPIRED = new Event('TokenIsExpired')
const storage = new AppStorage(storagePrefix, sessionStorage)

export function verifyToken(token: string, closeSessionCallbackFn: () => void) {
  if (isEmpty(token)) {
    closeSession(closeSessionCallbackFn)
  }
  const decoded = jwt_decode<{ exp?: number }>(token)
  if (decoded && decoded.exp) {
    const now_unix = Math.round(+new Date() / 1000)
    const expirationTime = decoded.exp - now_unix
    if (expirationTime < 0) {
      closeSession(closeSessionCallbackFn)
    }
    const halfAnHour = 60 * 30
    return expirationTime < halfAnHour
  }
  closeSession(closeSessionCallbackFn)
  return false
}

export function resetStorage() {
  storage.remove('isTokenExpired')
  storage.remove('redirectToPage')
}

export function populateStorage() {
  const pathname = window.location.pathname
  storage.set('isTokenExpired', true)
  if (Routes.loginPage !== pathname) {
    storage.set('redirectToPage', pathname)
  }
}

export function closeSession(closeSessionCallbackFn: () => void) {
  const authService = new AuthService()
  authService.logoutIdn()
  storage.purge()
  populateStorage()
  document.dispatchEvent(EVENT_TOKEN_EXPIRED)
  if (typeof closeSessionCallbackFn === 'function') {
    closeSessionCallbackFn()
  }
  console.warn('Token has expired!')
}

export function refreshToken(
  tokenName: keyof Token,
  closeSessionCallbackFn: () => void
) {
  const refreshToken: string = storage.get('refreshToken')
  const token: string = storage.get(tokenName)
  if (!refreshToken || !token) {
    closeSession(closeSessionCallbackFn)
  }
  const shouldRefreshToken = verifyToken(token, closeSessionCallbackFn)
  if (shouldRefreshToken) {
    const authService = new AuthService()
    authService.refreshToken().then(
      () => {},
      () => {
        closeSession(closeSessionCallbackFn)
      }
    )
  }
}
